import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CancelIcon from '../../assets/icons/CancelIcon';
import {
  RemoveHeader,
  RemoveText,
  CtaWrapper,
  RemoveModal,
  RemoveContent,
  IconWrapper,
  PrimaryCta,
  SecondaryCta,
  Wrapper,
} from './FilterTags.style';
import useLockBodyScroll from '../../hooks/UI/useLockBodyScroll';
import useAnimations from '../../hooks/Animations/useAnimations';
import useOnClickOutside from '../../hooks/UI/useOnClickOutside';

interface RemoveFilterModalProps {
  isModalOpen: boolean;
  filterUserWantToRemove: { filterType: string; filterValue: string };
  handleRemoveFilter: (filterType: string, filterValue: string) => void;
  setIsModalOpen: (arg: boolean) => void;
}

const RemoveFilterModal: React.FC<RemoveFilterModalProps> = ({
  isModalOpen,
  filterUserWantToRemove,
  handleRemoveFilter,
  setIsModalOpen,
}) => {
  const { t } = useTranslation();
  useLockBodyScroll(isModalOpen);

  const { removeFilterAnimation, blackBackgroundAnimation } = useAnimations(isModalOpen);
  const { filterType, filterValue } = filterUserWantToRemove;

  const onHandleClick = () => {
    handleRemoveFilter(filterType, filterValue);
    setIsModalOpen(false);
  };

  const modalRef = useRef(null);

  useOnClickOutside(
    modalRef,
    useCallback(() => setIsModalOpen(false), [setIsModalOpen]),
  );
  return (
    <>
      {blackBackgroundAnimation(
        (props, item) =>
          item && (
            <Wrapper style={props}>
              <RemoveModal style={removeFilterAnimation} ref={modalRef}>
                <RemoveHeader>
                  <IconWrapper>
                    <CancelIcon width={48} />
                  </IconWrapper>
                </RemoveHeader>
                <RemoveContent>
                  <RemoveText>{t('vlp.vehicleResults.removeFilter.label')}</RemoveText>
                  <CtaWrapper>
                    <PrimaryCta onClick={onHandleClick}>
                      {t('vlp.vehicleResults.removeFilter.yes')}
                    </PrimaryCta>
                    <SecondaryCta onClick={() => setIsModalOpen(false)}>
                      {t('vlp.vehicleResults.removeFilter.no')}
                    </SecondaryCta>
                  </CtaWrapper>
                </RemoveContent>
              </RemoveModal>
            </Wrapper>
          ),
      )}
    </>
  );
};

export default RemoveFilterModal;
